import styled from 'styled-components';
import theme from '|/components/base/theme';
import CloseLarge from '|/icons/close-large.svg';

export const Wrapper = styled.div`
  background-color: var(--colors-neutral-gray-1);
  z-index: var(--layers-order-summary);
  width: 100%;
  margin-top: 28px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 0.5rem;

  @media (min-width: ${theme.breakpoints.md}) {
    flex-direction: row;
    margin: 0 2rem;
  }

  @media (min-width: ${theme.breakpoints.lg}) {
    margin: 0 4rem;
  }
`;

export const Column = styled.div`
  width: 100%;
  padding-top: 1rem;

  @media (min-width: ${theme.breakpoints.md}) {
    padding-top: 2rem;
  }

  @media (min-width: ${theme.breakpoints.lg}) {
    width: 50%;
  }
`;

export const Panel = styled.div`
  padding: 40px 5px;
  margin: 0 1rem;

  @media (min-width: ${theme.breakpoints.sm}) {
    width: 87%;
    padding: 40px 20px;
    margin: 0 auto;
  }

  &:first-child {
    padding: 0 5px 40px;

    @media (min-width: ${theme.breakpoints.sm}) {
      width: 87%;
      padding: 0 20px 40px;
    }
  }

  &:not(:last-child) {
    border-bottom: 2px dotted #d0d0d0;
  }
`;

export const LineWrapper = styled.div`
  padding-top: 1rem;
  font-size: 1rem;

  @media (min-width: ${theme.breakpoints.sm}) {
    font-size: 1.2rem;
  }
`;

export const LineItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 0.5rem;
`;

export const SubHeading = styled.p`
  color: #757989;
  display: none;
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  margin-top: 15px !important;
  white-space: pre-line;
  line-height: 28px;

  @media (min-width: ${theme.breakpoints.sm}) {
    display: block;
  }
`;

export const Heading = styled.h1`
  color: #183558;
  display: none;
  font-size: 22px;
  margin: 30px 0 30px 30px;

  @media (min-width: ${theme.breakpoints.sm}) {
    display: block;
    font-size: 24px;
  }

  @media (min-width: ${theme.breakpoints.sm}) {
    margin: 40px 0 20px;
  }
`;

export const OrderSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledCloseLarge = styled(CloseLarge)`
  cursor: pointer;
  align-self: flex-end;
  display: block;
  margin-top: -35px;
  color: #666;
  float: right;
`;
